import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            {/* Option 1: Logo with text */}
            <img 
              src="/Infi_Tool_logo_with_text.png" 
              alt="Infi Tools Logo" 
              className="logo-image"
            />
            <span className="logo-text">Infi Tools</span>
            
            {/* Option 2: Logo only (uncomment to use) */}
            {/* <img 
              src="/Infi_Tool_logo_with_text.png" 
              alt="Infi Tools" 
              className="logo-image-only"
            /> */}
          </Link>
          <nav>
            <Link to="/" className="btn btn-secondary">
              Home
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header; 